import type { WalletInfoModel, WalletInfoResponseDto } from '../../data-layer/cpa/types';

export const toWalletInfoModel = (dto: WalletInfoResponseDto): WalletInfoModel => ({
    balance: dto.wallet_info.balance,
    isTrial: dto.wallet_info.is_trial,
    contractAvailable: dto.wallet_info.contract_available,
    expireAt: dto.wallet_info.expire_at,
});
